import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import lazyLocaleBackend from './lazyLocaleBackend';

import enCommon from '../locales/en/common.json';
import enAuth from '../locales/en/auth.json';
import enShop from '../locales/en/shop.json';

import plCommon from '../locales/pl/common.json';
import plAuth from '../locales/pl/auth.json';
import plShop from '../locales/pl/shop.json';

const syncDocumentHtmlLang = (lng) => {
  if (typeof document === 'undefined') return;
  const code = String(lng || 'pl').split('-')[0];
  document.documentElement.setAttribute('lang', code === 'en' || code === 'pl' ? code : 'pl');
};

i18n.on('languageChanged', syncDocumentHtmlLang);

/** Loaded eagerly — AppContext, header cart, auth flows need these without async wait. */
const bootstrapResources = {
  en: { common: enCommon, auth: enAuth, shop: enShop },
  pl: { common: plCommon, auth: plAuth, shop: plShop },
};

i18n
  .use(lazyLocaleBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: bootstrapResources,
    partialBundledLanguages: true,
    supportedLngs: ['pl', 'en'],
    fallbackLng: 'pl',
    load: 'languageOnly',
    debug: false,
    showSupportNotice: false,

    interpolation: {
      escapeValue: false,
    },

    detection: {
      order: ['localStorage'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },

    // Only bootstrap namespaces here — lazy ones (incl. onboarding) load via useTranslation.
    // Listing lazy ns in `ns` with partialBundledLanguages can leave them stuck on fallbackLng.
    ns: ['common', 'auth', 'shop'],
    defaultNS: 'common',

    missingKeyHandler: (lng, ns, key, _fallbackValue) => {
      if (process.env.NODE_ENV === 'development') {
        console.warn(`Missing translation: ${lng}:${ns}:${key}`);
      }
    },

    react: {
      useSuspense: false,
    },
  })
  .then(() => {
    syncDocumentHtmlLang(i18n.resolvedLanguage || i18n.language);
  });

export default i18n;
